<template>
  <div>
    <div class="back_logo">
      <img v-if="back_logo" src="../../../assets/images/banner_02.jpg" alt>
      <img v-else src="../../../assets/images/banner_02.jpg" alt>
    </div>
    <div class="pdf">
      <div class="handbook">
        <div class="hand">
            <div class="hand-left">
                <div class="hand-left-APP" :class="clickColor==0?'click-color':'default-color'" @click='AppShow(0)'>
                    <span>APP端</span>
                </div>
                <div class="hand-left-PC" :class="clickColor==1?'click-color':'default-color'" @click='AppShow(1)'>
                    <span>PC端</span>
                </div>
            </div>
            <div class="hand-right" v-show='show'>
                <div class="hand-right-top">
                    <h2 class="hand-title">APP端</h2>
                </div>
                <div class="hand-right-bottom">
                    <ul class="hand-info">
                        <li
                            :class="listwidth"
                            v-for="(item, index) in list"
                            :key="item.id"
                            v-if="index>=2"
                            @click="toDetail(item.url,item.name,item.id)"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
            <div class="hand-right" v-show='!show'>
                <div class="hand-right-top">
                    <h2 class="hand-title">PC端</h2>
                </div>
                <div class="hand-right-bottom">
                    <ul class="hand-info">
                        <li
                            :class="listwidth"
                            v-for="(item, index) in list"
                            :key="item.id"
                            v-if="index<2"
                            @click="toDetail(item.url,item.name,item.id)"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import pdf from 'vue-pdf'
export default {
    components: {
        // pdf
    },
    name: "index",
    data() {
        return {
            back_logo: false,
            src: "static/pdf/格局云后台-如何发布公告.pdf",
            currentPage: 0,
            pageCount: 0,
            list: [
                {
                    id: 1,
                    name: "如何发布网页版公告",
                    url: "static/pdf/ruhefabuwangyegonggao.pdf"
                },
                {
                    id: 2,
                    name: "如何修改会员的信息",
                    url: "static/pdf/ruhexiugaihuiyuanxinxi.pdf"
                },
                {
                    id: 3,
                    name: "如何下载并登录格局云",
                    url: "static/pdf/ruhexiazaibingdenglugejuyun.pdf"
                },
                {
                    id: 4,
                    name: "如何发布手机版公告",
                    url: "static/pdf/ruhefabushoujibangonggao.pdf"
                },
                {
                    id: 5,
                    name: "如何修改已有分组",
                    url: "static/pdf/ruhexiugaiyiyoufenzu.pdf"
                },
                {
                    id: 6,
                    name: "如何创建活动报名",
                    url: "static/pdf/ruhechuangjianhuodongbaoming.pdf"
                },
                { 
                    id: 7,
                    name: "如何创建组织", 
                    url: "static/pdf/ruhechuangjianzuzhi.pdf"
                },
                {
                    id: 8,
                    name: "如何发起会员缴费",
                    url: "static/pdf/ruhefaqihuiyuanjiaofei.pdf"
                },
                {
                    id: 9,
                    name: "如何发起活动签到",
                    url: "static/pdf/ruhefaqihongdongqiandao.pdf"
                },
                {
                    id: 10,
                    name: "如何在手机上上传视频",
                    url: "static/pdf/ruhezaishoujishangshangchuangshipin.pdf"
                },
                {
                    id: 11,
                    name: "如何在手机上图片直播",
                    url: "static/pdf/ruhezaishoujishangshipinzhibo.pdf"
                },
                {
                    id: 12,
                    name: "如何在手机上视频直播",
                    url: "static/pdf/ruhezaishoujishangtupianzhibo.pdf"
                },
                {
                    id: 13,
                    name: "如何给组织添加分组",
                    url: "static/pdf/ruhegeizuzhitianjiafenzu.pdf"
                },
                {
                    id: 14,
                    name: "格局云会员卡操作手册",
                    url: "static/pdf/gejuyunhuiyuankacaozuoshouce.pdf"
                },
                {
                    id: 15,
                    name: "格局云后台-如何发布公告",
                    url: "static/pdf/gejuyunhoutai-ruhefabugonggao.pdf"
                }
            ],
            listwidth: "",
            listflex: "",
            show: true,
            clickColor: 0
        }
    },
    created() {
        // console.log('created')
    },
    mounted() {
        const u = navigator.userAgent;
        // const app = navigator.appVersion
        const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
        const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid != true && isIOS != true) {
            this.back_logo = false;
            this.listwidth = "list-width";
            this.listflex = "list-flex";
        } else {
            this.back_logo = true;
            this.listwidth = "";
            this.listflex = "";
        }
        this.currentPage = 1;
        // this.src = pdf.createLoadingTask(this.src)
    },
    methods: {
        changePdfPage(val) {
            //翻页
            if (val === 0 && this.currentPage > 1) {
                this.currentPage--;
            }
            if (val === 1 && this.currentPage < this.pageCount) {
                this.currentPage++;
            }
        },
        toDetail(url, name, id) {
        // this.$router.back(-1)
            this.$router.push({
                path: "/detail",
                query: { url: url, name: name ,id: id}
                // name: 'detail', params: { url: url }
            });
        },
        AppShow: function(index) {
            this.show = !this.show
            this.clickColor = index
        }
  }
};
</script>

<style lang='css' scoped>
html,body{
    overflow:hidden;
}
.default-color {
  color: #323232;
  background: #cdd5da;
}
.click-color {
  color: #fff;
  background: #38adff;
}
.pdf {
    padding:2%;
    overflow:hidden;
}
.back_logo {
  width: 100%;
}
.back_logo img {
  width: 100%;
  height: 100%;
}
.title {
  font-weight: bold;
  padding-bottom: 5%;
}
.content-list {
  padding: 2% 10%;
  text-align: center;
  border: 1px solid #cbcece;
  margin-bottom: 6px;
  cursor: pointer;
}
.list-width {
}
.list-flex {
  display: flex;
  flex-wrap: wrap;
}
.handbook {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.hand {
  width: 80%;
  padding: 40px 15px 15px 15px;
  display: flex;
  box-sizing: border-box;
}

.hand-left {
  flex: 0 0 240px;
  color: #323232;
  font-size: 18px;
  box-sizing: border-box;
}

.hand-left-APP,
.hand-left-PC {
  padding: 15px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.hand-right {
  width: 100%;
  padding-left: 30px;
}

.hand-right-top {
  width: 100%;
  height: 93.2px;
  border-bottom: 1px solid #323232;
}

.hand-title {
  font-size: 24px;
  font-weight: 600;
}

.hand-right-bottom {
  cursor: pointer;
}

.hand-info {
  font-size: 16px;
  color: #38adff;
}

li {
  padding: 15px 15px 0 20px;
  position: relative;
}

li::before {
  content: "";
  width: 15px;
  height: 15px;
  position: absolute;
  background: #38adff;
  left: 0;
  border-radius: 50%;
}
</style>
